<!-- The script editor's outline (#scriptToc): headings 1–3 of the page, sticky on the left from 1024 px (in ScriptEditor.vue's left box, with the tabs); below it opens
     over the page from #tocBtn (.toc-open; from the bottom on phones). State in the toc store (src/stores/toc.ts): drawn
     again at every render (key), the active heading marked. Ported from the legacy editor.js renderToc. -->
<script setup lang="ts">
import { useI18n } from '../../composables/useI18n'
import { useTocStore } from '../../stores/toc'

const { t } = useI18n()
const toc = useTocStore()
</script>

<template>
  <aside id="scriptToc" :class="['script-toc hidden lg:block w-56 flex-shrink-0', { 'toc-open': toc.open }]">
    <template v-if="toc.seq">
      <div :key="'h' + toc.seq" class="flex items-center justify-between px-2 mb-2"><span class="text-[11px] font-bold uppercase tracking-wider text-gray-500"><i class="fas fa-list mr-1.5"></i>{{ t('Contents') }}</span><button type="button" class="lg:hidden text-gray-500 hover:text-gray-100" @click="toc.toggle(false)"><i class="fas fa-xmark"></i></button></div>
      <template v-if="toc.items.length">
        <button v-for="(h, i) in toc.items" :key="toc.seq + ':' + i" type="button" :title="h.text" :class="['toc-it', 'toc-' + h.level, { on: i === toc.active }]" @mousedown.prevent @click="toc.go(i)">{{ h.text }}</button>
      </template>
      <p v-else :key="'e' + toc.seq" class="px-2 text-xs text-gray-500 leading-relaxed">{{ t('The script headings appear here (Heading 1, 2 and 3): tap one to jump to it.') }}</p>
    </template>
  </aside>
</template>
